export default {
  getSelectedFilters: state => {
    return state.filterRegistry;
  },
  getAllFilters: state => {
    return state.filterData;
  },
  getAppliedFilters: state => {
    return state.appliedFilters;
  },
  getLockedFilters: state => {
    return state.lockedFilters;
  },
  getCustomFilters: state => {
    return state.customFilterRegistry;
  },
};
